import React, { useState } from 'react';
import Sprites from "styles/EG2023/EG2023sprites.svg";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import Label from 'components/general/Label';

export function FooterEG2023() {
    const linksEng = {
        urlWhoWeAre: "https://www.european-games.org/the-games/who-we-are/",
        urlAboutEOC: "https://www.european-games.org/institutional/about-eoc/",
        urlCountries: "https://www.european-games.org/participating-countries",
        urlVenues: "https://www.european-games.org/venues",
        urlTorchJourney: "https://www.european-games.org/the-games/torch-relay/",
        urlMascots: "http://localhost:3000/https://www.european-games.org/the-games/mascots/",
        urlTicketing: "https://www.european-games.org/the-games/ticketing/",
        urlDeclarationofAccessibility: "https://www.european-games.org/accesibilily/",
        url3x3Basketball: "https://www.european-games.org/sports/basketball-3x3/",
        urlArchery: "https://www.european-games.org/sports/archery/",
        urlArtisticSwimming: "https://www.european-games.org/sports/artistic-swimming/",
        urlAthletics: "https://www.european-games.org/sports/athletics/",
        urlBadminton: "https://www.european-games.org/sports/badminton/",
        urlBeachHandball: "https://www.european-games.org/sports/beach-handball/",
        urlBeachSoccer: "https://www.european-games.org/sports/beach-soccer/",
        urlBoxing: "https://www.european-games.org/sports/boxing/",
        urlBreaking: "https://www.european-games.org/sports/breaking/",
        urlCanoeSlalom: "https://www.european-games.org/sports/canoe-slalom/",
        urlCanoeSprint: "https://www.european-games.org/sports/canoe-sprint/",
        urlCyclingBMXFreestyle: "https://www.european-games.org/sports/cycling-bmx-freestyle/",
        urlCyclingMountainBike: "https://www.european-games.org/sports/cycling-mountain-bike/",
        urlDiving: "https://www.european-games.org/sports/diving/",
        urlFencing: "https://www.european-games.org/sports/fencing/",
        urlJudo: "https://www.european-games.org/sports/judo/",
        urlKarate: "https://www.european-games.org/sports/karate/",
        urlKickboxing: "https://www.european-games.org/sports/kickboxing/",
        urlModernPentathlon: "https://www.european-games.org/sports/modern-pentathlon/",
        urlMuaythai: "https://www.european-games.org/sports/muaythai/",
        urlPadel: "https://www.european-games.org/sports/padel/",
        urlRugbySevens: "https://www.european-games.org/sports/rugby-sevens/",
        urlShooting: "https://www.european-games.org/sports/shooting/",
        urlSkiJumping: "https://www.european-games.org/sports/ski-jumping/",
        urlSportClimbing: "https://www.european-games.org/sports/sport-climbing/",
        urlTableTennis: "https://www.european-games.org/sports/table-tennis/",
        urlTaekwondo: "https://www.european-games.org/sports/taekwondo/",
        urlTeqball: "https://www.european-games.org/sports/teqball/",
        urlTriathlon: "https://www.european-games.org/sports/triathlon/",
        urlImageGalleries: "https://www.european-games.org/multimedia/galleries",
        urlNews: "https://www.european-games.org/news/",
        urlBIP: "https://bip.malopolska.pl/ie2023",
        urlVolunteersPortal: "https://volunteers.european-games.org/login",
        urlWorkWithUs: "https://www.european-games.org/work-with-us/",
        urlAccreditationProcess: "https://www.european-games.org/accreditation-process/",
        urlLegalNotice: "https://www.european-games.org/legal-notice/",
        urlPrivacyPolicy: "https://www.european-games.org/privacy-policy/",
        urlCookiePolicy: "https://www.european-games.org/cookie-policy/"
    }

    const linksPol = {
        urlWhoWeAre: "https://www.european-games.org/pl/igrzyska/o-nas/",
        urlAboutEOC: "https://www.european-games.org/pl/komitet-organizacyjny/czym-jest-eoc/",
        urlCountries: "https://www.european-games.org/pl/participating-countries/",
        urlVenues: "https://www.european-games.org/pl/obiekty/",
        urlTorchJourney: "https://www.european-games.org/pl/igrzyska/sztafeta-z-ogniem-pokoju/",
        urlMascots: "https://www.european-games.org/pl/igrzyska/maskotki/",
        urlTicketing: "https://www.european-games.org/pl/igrzyska/ticketing/",
        urlDeclarationofAccessibility: "https://www.european-games.org/pl/deklaracja-dostepnosci/",
        url3x3Basketball: "https://www.european-games.org/pl/sporty/koszykowka-3x3/",
        urlArchery: "https://www.european-games.org/pl/sporty/tucznictwo/",
        urlArtisticSwimming: "https://www.european-games.org/pl/sporty/plywanie-artystyczne/",
        urlAthletics: "https://www.european-games.org/pl/sporty/lekkoatletyka/",
        urlBadminton: "https://www.european-games.org/pl/sporty/badminton/",
        urlBeachHandball: "https://www.european-games.org/pl/sporty/pitka-reczna-plazowa/",
        urlBeachSoccer: "https://www.european-games.org/pl/sporty/pitka-nozna-plazowa/",
        urlBoxing: "https://www.european-games.org/pl/sporty/boks/",
        urlBreaking: "https://www.european-games.org/pl/sporty/breaking/",
        urlCanoeSlalom: "https://www.european-games.org/pl/sporty/kajakarstwo-slalomowe/",
        urlCanoeSprint: "https://www.european-games.org/pl/sporty/kajakarstwo-sprint/",
        urlCyclingBMXFreestyle: "https://www.european-games.org/pl/sporty/bmx-freestyle/",
        urlCyclingMountainBike: "https://www.european-games.org/pl/sporty/kolarstwo-gorskie/",
        urlDiving: "https://www.european-games.org/pl/sporty/skoki-do-wody/",
        urlFencing: "https://www.european-games.org/pl/sporty/szermierka/",
        urlJudo: "https://www.european-games.org/pl/sporty/judo/",
        urlKarate: "https://www.european-games.org/pl/sporty/karate/",
        urlKickboxing: "https://www.european-games.org/pl/sporty/kickboxing/",
        urlModernPentathlon: "https://www.european-games.org/pl/sporty/piecioboj-nowoczesny/",
        urlMuaythai: "https://www.european-games.org/pl/sporty/muaythai/",
        urlPadel: "https://www.european-games.org/pl/sporty/padel/",
        urlRugbySevens: "https://www.european-games.org/pl/sporty/rugby-siedem/",
        urlShooting: "https://www.european-games.org/pl/sporty/strzelectwo/",
        urlSkiJumping: "https://www.european-games.org/pl/sporty/skoki-narciarskie/",
        urlSportClimbing: "https://www.european-games.org/pl/sporty/wspinaczka-sportowa/",
        urlTableTennis: "https://www.european-games.org/pl/sporty/tenis-stolowy/",
        urlTaekwondo: "https://www.european-games.org/pl/sporty/taekwondo/",
        urlTeqball: "https://www.european-games.org/pl/sporty/teqball/",
        urlTriathlon: "https://www.european-games.org/pl/sporty/triathlon/",
        urlImageGalleries: "https://www.european-games.org/pl/multimedia/galleries/",
        urlNews: "https://www.european-games.org/pl/aktualnosci/",
        urlBIP: "https://bip.malopolska.pl/ie2023",
        urlVolunteersPortal: "https://volunteers.european-games.org/login",
        urlWorkWithUs: "https://www.european-games.org/pl/kariera/",
        urlAccreditationProcess: "https://www.european-games.org/pl/proces-akredytacji/",
        urlLegalNotice: "https://www.european-games.org/pl/status-prawny/",
        urlPrivacyPolicy: "https://www.european-games.org/pl/polityka-prywatnosci-strony-internetowej/",
        urlCookiePolicy: "https://www.european-games.org/pl/polityka-cookie/"
    }

    const { mirs_language } = useUrlFriendlyToParameters()

    const link = mirs_language === "ENG" ? linksEng : linksPol

    return (

        <div className="EG2023-footer">
            <div className="footer-wrapper dm dm-bg dm-invert">
                <svg className="ornament">
                    <use xlinkHref={`${Sprites}#flame_trama`} />
                </svg>

                <div className="container position-relative">
                    <div className="row align-items-center">
                        <div className="col-lg-3">
                            <div className="logo_footer">
                                <svg className="dm">
                                    <use href={`${Sprites}#logoeg2023_inv`} />
                                </svg>
                            </div>


                        </div>

                        <div className="col-lg-7 text-center">

                            <div className="logo-Atos"> <img aria-hidden="true" src="/assets/images/logoAtos.png" alt="Atos Mayor Events" /></div>
                        </div>

                        <div className="col-lg-2">
                            <div className="social-icons">
                                <span><Label data={'Footer_FollowUs'} /></span>
                                <ul>
                                    <li>
                                        <a href="https://www.facebook.com/IgrzyskaEuropejskie2023" target="_blank">
                                            <svg className="icon">
                                                <use xlinkHref={`${Sprites}#facebook`} />

                                            </svg><span className="sr-only"><Label data={'Footer_GotoFacebookProfile'} /></span></a></li>

                                    <li>
                                        <a href="https://www.instagram.com/europeangames2023/" target="_blank">
                                            <svg className="icon">
                                                <use xlinkHref={`${Sprites}#instagram`} />

                                            </svg><span className="sr-only"><Label data={'Footer_GotoInstagramProfile'} /></span></a></li>

                                    <li>
                                        <a href="https://twitter.com/eg2023en" target="_blank">
                                            <svg className="icon">
                                                <use xlinkHref={`${Sprites}#twitter`} />

                                            </svg><span className="sr-only"><Label data={'Footer_GotoTwitterProfile'} /></span></a></li>

                                    <li>
                                        <a href="https://www.youtube.com/channel/UCXlSkkakMpW42J-UEbC2xXA/featured" target="_blank">
                                            <svg className="icon">
                                                <use xlinkHref={`${Sprites}#youtube`} />

                                            </svg><span className="sr-only"><Label data={'Footer_GotoYoutubeProfile'} /></span></a></li>

                                    <li>
                                        <a href="https://www.tiktok.com/@europeangames2023" target="_blank">
                                            <svg className="icon">
                                                <use xlinkHref={`${Sprites}#tiktok`} />

                                            </svg><span className="sr-only"><Label data={'Footer_GotoTikTokProfile'} /></span></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-8">
                            <span><Label data={'Footer_Institutional'} /></span>
                            <div className="institucional">
                                <section id="block-2" className="widget widget_block">
                                    <p><span>European Games 2023 Ltd.</span></p>
                                    <p><Label data={'Footer_Adress'} /></p>
                                    <p><Label data={'Footer_Phone'} />:  <a href="tel:+48729055132" target="_blank">+48 729 055 132</a></p>
                                    <p>E-mail: <a href="mailto:office@ie2023.pl" target="_blank">office@ie2023.pl</a></p>
                                </section>
                                <section id="block-3" className="widget widget_block">
                                    <p><span><Label data={'Footer_PressOffice'} />:</span></p>
                                    <p><a target="_blank" href="mailto:media@ie2023.pl">media@ie2023.pl</a></p>
                                </section>
                                <section id="block-4" className="widget widget_block">
                                    <p><span><Label data={'Footer_VolunteerDepartment'} />:</span> </p>
                                    <p><a target="_blank" href="mailto:wolontariat@ie2023.pl">wolontariat@ie2023.pl</a></p>
                                </section>
                                <section id="block-5" className="widget widget_block">
                                    <p><span><Label data={'Footer_Marketing'} />:</span></p>
                                    <p><a target="_blank" href="mailto:marketing@ie2023.pl">marketing@ie2023.pl</a></p>
                                </section>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4">
                            <span><Label data={'Footer_EuropeanGames'} /></span>
                            <ul id="menu-footer-main" className="menu">
                                <li className=" menu-item menu-item-type-post_type menu-item-object-page level-0">
                                    <a href={link.urlWhoWeAre} target="_blank"><Label data={'Footer_WhoWeAre'} /></a>
                                </li>
                                <li className=" menu-item menu-item-type-post_type menu-item-object-page level-0">
                                    <a href={link.urlAboutEOC} target="_blank"><Label data={'Footer_AboutEOC'} /></a>
                                </li>
                                <li className=" menu-item menu-item-type-custom menu-item-object-custom level-0">
                                    <a href={link.urlCountries} target="_blank"><Label data={'Footer_Countries'} /></a></li>
                                <li className=" menu-item menu-item-type-custom menu-item-object-custom level-0">
                                    <a href={link.urlVenues} target="_blank"><Label data={'Footer_Venues'} /></a></li>
                                <li className=" menu-item menu-item-type-post_type menu-item-object-page level-0">
                                    <a href={link.urlTorchJourney} target="_blank"><Label data={'Footer_TorchJourney'} /></a></li>
                                <li className=" menu-item menu-item-type-post_type menu-item-object-page level-0">
                                    <a href={link.urlMascots} target="_blank"><Label data={'Footer_Mascots'} /></a></li>
                                <li className=" menu-item menu-item-type-custom menu-item-object-custom level-0">
                                    <a href={link.urlTicketing} target="_blank"><Label data={'Footer_Ticketing'} /></a></li>
                                <li className=" menu-item menu-item-type-post_type menu-item-object-page level-0">
                                    <a href={link.urlDeclarationofAccessibility} target="_blank"><Label data={'Footer_DeclarationofAccessibility'} /></a></li>
                            </ul>
                        </div>

                        <div className="col-lg-4 col-md-8">
                            <span><Label data={'Footer_SPORTS'} /></span>
                            <div className="two-cols">
                                <ul>
                                    <li><a href={link.url3x3Basketball} target="_blank"><Label data={'Footer_BK3'} /></a></li>
                                    <li><a href={link.urlArchery} target="_blank"><Label data={'Footer_ARC'} /></a></li>
                                    <li><a href={link.urlArtisticSwimming} target="_blank"><Label data={'Footer_SWA'} /></a></li>
                                    <li><a href={link.urlAthletics} target="_blank"><Label data={'Footer_ATH'} /></a></li>
                                    <li><a href={link.urlBadminton} target="_blank"><Label data={'Footer_BDM'} /></a></li>
                                    <li><a href={link.urlBeachHandball} target="_blank"><Label data={'Footer_HBB'} /></a></li>
                                    <li><a href={link.urlBeachSoccer} target="_blank"><Label data={'Footer_BSC'} /></a></li>
                                    <li><a href={link.urlBoxing} target="_blank"><Label data={'Footer_BOX'} /></a></li>
                                    <li><a href={link.urlBreaking} target="_blank"><Label data={'Footer_BRE'} /></a></li>
                                    <li><a href={link.urlCanoeSlalom} target="_blank"><Label data={'Footer_CSL'} /></a></li>
                                    <li><a href={link.urlCanoeSprint} target="_blank"><Label data={'Footer_CSP'} /></a></li>
                                    <li><a href={link.urlCyclingBMXFreestyle} target="_blank"><Label data={'Footer_BMX'} /></a></li>
                                    <li><a href={link.urlCyclingMountainBike} target="_blank"><Label data={'Footer_MTB'} /></a></li>
                                    <li><a href={link.urlDiving} target="_blank"><Label data={'Footer_DIV'} /></a></li>
                                    <li><a href={link.urlFencing} target="_blank"><Label data={'Footer_FEN'} /></a></li>
                                    <li><a href={link.urlJudo} target="_blank"><Label data={'Footer_JUD'} /></a></li>
                                    <li><a href={link.urlKarate} target="_blank"><Label data={'Footer_KAR'} /></a></li>
                                    <li><a href={link.urlKickboxing} target="_blank"><Label data={'Footer_KIK'} /></a></li>
                                    <li><a href={link.urlModernPentathlon} target="_blank"><Label data={'Footer_MPN'} /></a></li>
                                    <li><a href={link.urlMuaythai} target="_blank"><Label data={'Footer_MTI'} /></a></li>
                                    <li><a href={link.urlPadel} target="_blank"><Label data={'Footer_PDL'} /></a></li>
                                    <li><a href={link.urlRugbySevens} target="_blank"><Label data={'Footer_RU7'} /></a></li>
                                    <li><a href={link.urlShooting} target="_blank"><Label data={'Footer_SHO'} /></a></li>
                                    <li><a href={link.urlSkiJumping} target="_blank"><Label data={'Footer_SJP'} /></a></li>
                                    <li><a href={link.urlSportClimbing} target="_blank"><Label data={'Footer_CLI'} /></a></li>
                                    <li><a href={link.urlTableTennis} target="_blank"><Label data={'Footer_TTE'} /></a></li>
                                    <li><a href={link.urlTaekwondo} target="_blank"><Label data={'Footer_TKW'} /></a></li>
                                    <li><a href={link.urlTeqball} target="_blank"><Label data={'Footer_TEQ'} /></a></li>
                                    <li><a href={link.urlTriathlon} target="_blank"><Label data={'Footer_TRI'} /></a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-2 col-md-4">
                            <span><Label data={'Footer_GameOn'} /></span>
                            <ul id="menu-footer-game-on" className="menu">
                                <li className=" menu-item menu-item-type-custom menu-item-object-custom level-0">
                                    <a href={link.urlImageGalleries} target="_blank"><Label data={'Footer_ImageGalleries'} /></a></li>
                                <li className=" menu-item menu-item-type-post_type menu-item-object-page level-0">
                                    <a href={link.urlNews} target="_blank"><Label data={'Footer_News'} /></a></li>
                            </ul>
                            <span><span><Label data={'Footer_BeWithUs'} /></span></span>
                            <ul id="menu-footer-be-with-us" className="menu">
                                <li className=" menu-item menu-item-type-custom menu-item-object-custom level-0">
                                    <a href={link.urlBIP} target="_blank"><Label data={'Footer_BIP'} /></a></li>
                                <li className=" menu-item menu-item-type-custom menu-item-object-custom level-0">
                                    <a href={link.urlVolunteersPortal} target="_blank"><Label data={'Footer_VolunteersPortal'} /></a></li>
                                <li className=" menu-item menu-item-type-post_type menu-item-object-page level-0">
                                    <a href={link.urlWorkWithUs} target="_blank"><Label data={'Footer_WorkWithUs'} /></a></li>
                                <li className=" menu-item menu-item-type-post_type menu-item-object-page level-0">
                                    <a href={link.urlAccreditationProcess} target="_blank"><Label data={'Footer_Accreditationprocess'} /></a></li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>
            <div className="bottom-bar dm">
                <div className="container">
                    <div className="container">
                        <div className="bottom-bar-wrapper">
                            <span>
                                <Label data={'Footer_Copyright'} /></span>
                            <ul id="menu-footer-legal" className="menu">
                                <li className=" menu-item menu-item-type-post_type menu-item-object-page level-0">
                                    <a href={link.urlLegalNotice} target="_blank"><Label data={'Footer_LegalNotice'} /></a></li>
                                <li className=" menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy level-0">
                                    <a href={link.urlPrivacyPolicy} target="_blank"><Label data={'Footer_PrivacyPolicy'} /></a>
                                </li>
                                <li className=" menu-item menu-item-type-post_type menu-item-object-page level-0">
                                    <a href={link.urlCookiePolicy} target="_blank"><Label data={'Footer_CookiePolicy'} /></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )


};
export default FooterEG2023